import React from 'react';
import { Send, Calendar, FileText, CheckCircle2, Clock, XCircle } from 'lucide-react';

const RequestsSection = ({ caseData, portalType = 'individual' }) => {
  const primaryColor = portalType === 'business' ? '#1E3A8A' : '#10B981';
  const getStatusIcon = (status) => {
    switch (status) {
      case 'مكتمل':
        return <CheckCircle2 className="w-6 h-6 text-white" strokeWidth={2.5} />;
      case 'قيد المعالجة':
        return <Clock className="w-6 h-6 text-white" strokeWidth={2.5} />;
      default:
        return <XCircle className="w-6 h-6 text-white" strokeWidth={2.5} />;
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border-2 border-gray-200 p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-[#8B5CF6] to-[#A78BFA] rounded-xl flex items-center justify-center">
          <Send className="w-7 h-7 text-white" strokeWidth={2.5} />
        </div>
        <h2 className="text-3xl font-black  style={{ color: primaryColor }}">الطلبات المقدمة أمام الجهة المختصة</h2>
      </div>

      {caseData.submittedRequests && caseData.submittedRequests.length > 0 ? (
        <div className="space-y-6">
          {caseData.submittedRequests.map((request) => (
            <div 
              key={request.id}
              className="border-2 border-gray-200 rounded-xl p-6 hover:border-[#8B5CF6] transition-all hover:shadow-lg bg-white"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div 
                    className="w-12 h-12 rounded-xl flex items-center justify-center"
                    style={{ background: `linear-gradient(to bottom right, ${request.statusColor}, ${request.statusColor}dd)` }}
                  >
                    {getStatusIcon(request.status)}
                  </div>
                  <div>
                    <h3 className="text-xl font-black text-gray-900">{request.title}</h3>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-xs font-bold">
                        {request.type}
                      </span>
                      <span className="text-sm text-gray-500 font-semibold">• {request.requestNumber}</span>
                    </div>
                  </div>
                </div>
                <span 
                  className="px-4 py-2 rounded-full text-sm font-bold"
                  style={{ 
                    backgroundColor: `${request.statusColor}20`,
                    color: request.statusColor
                  }}
                >
                  {request.status}
                </span>
              </div>

              <p className="text-gray-700 mb-4 leading-relaxed">{request.description}</p>

              {request.response && (
                <div className="bg-blue-50 rounded-lg p-4 mb-4">
                  <div className="flex items-center gap-2  style={{ color: primaryColor }} mb-2">
                    <FileText className="w-5 h-5" />
                    <span className="font-bold text-sm">رد الجهة المختصة</span>
                  </div>
                  <p className="text-gray-800 leading-relaxed">{request.response}</p>
                </div>
              )}

              <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                <div className="flex items-center gap-2 text-gray-700">
                  <Calendar className="w-5 h-5  style={{ color: primaryColor }}" />
                  <div>
                    <div className="text-xs text-gray-500 font-semibold">تاريخ التقديم</div>
                    <div className="font-bold">{request.date}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 text-gray-500">
          <Send className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <p className="text-lg font-bold">لا توجد طلبات مقدمة</p>
        </div>
      )}
    </div>
  );
};

export default RequestsSection;